module.exports = __webpack_public_path__ + "static/media/prev.ffb4c799.svg";